import React, { useEffect } from 'react'
import Signup from './components/Signup'
import Spinner from 'react-bootstrap/Spinner'
import Alert from 'react-bootstrap/Alert'

import { useQueryParam } from './hooks/use-query-param'
import { useAjax } from './hooks/use-ajax'

const App = () => {
  const courseId = useQueryParam('course_id')
  const [ajax, { error, loading, data: course }] = useAjax()
  useEffect(() => {
    if (courseId) {
      ajax.get('get_course', { courseId })
    }
  }, [])

  return (
    <div >
      {loading && (
        <div className="d-flex justify-content-center">
          <Spinner
            variant="primary"
            as="span"
            animation="border"
            role="status"
            aria-hidden="true"
          />
        </div>
      )}
      {(error || !courseId || (course === null)) && (
        <Alert variant="danger">
          Der Kurs für den du dich anmelden möchtest scheint nicht zu
          existieren.
        </Alert>
      )}
      {course && <Signup course={course} />}
    </div>
  )
}

export default App
